import React from 'react';
import styled from 'styled-components';

const Tile = styled.div<{ $highlighted: boolean }>`
  display: inline-block;
  width: 3px;
  height: 14px;
  margin: 0 2px;
  background: ${({ $highlighted }) =>
    $highlighted ? 'var(--red3a)' : 'var(--gray4)'};
  border-radius: 5px;
`;

export default function ADLIndicator({
  currentLiquidationChance,
}: {
  currentLiquidationChance: number; // 0 | 1 | 2 | 3 | 4 | 5;
}) {
  if (currentLiquidationChance < 0 || currentLiquidationChance > 5) {
    console.error('Liquidation chance out of boundary');
    return null;
  }
  return (
    <>
      {[1, 2, 3, 4, 5].map(chance => (
        <Tile key={chance} $highlighted={currentLiquidationChance >= chance} />
      ))}
    </>
  );
}
